import { FieldError } from 'react-hook-form/dist/index.ie11';
import { IFormInputMessage } from '@grubhubprod/gh-cookbook-react';

export type CheckboxValueType = string | boolean;

export function getPaths(
  name: string,
  values: Record<string, CheckboxValueType>
): string[] {
  return Object.keys(values).map((key) => `${name}.${key}`);
}

export function hasAnyValue(
  values: Record<string, CheckboxValueType>
): boolean {
  return Object.keys(values).length > 0;
}

export function extractErrorMessage(
  entry: Record<string, FieldError>
): undefined | IFormInputMessage {
  if (!entry) return undefined;

  return Object.values(entry).find(Boolean);
}
